import { useEffect, useState } from "react";
import { Crown, Trophy } from "lucide-react";
import { api } from "../lib/api";

// Public referral leaderboard — top referrers of the current 6-month season
// (Jan 1 / Jul 1 rollover). The #1 spot wins a free year of FORCE.
export default function ReferralLeaderboard({ variant = "classic" }) {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/referrals/leaderboard").then(({ data }) => setData(data)).catch(() => setData({ leaders: [] }));
    }, []);

    if (!data) return null;
    const ends = data.period_ends ? new Date(data.period_ends).toLocaleDateString(undefined, { month: "long", day: "numeric" }) : "";
    const shape = variant === "operations" ? "rounded-xl" : variant === "editorial" ? "rounded-[1.5rem]" : "rounded-2xl";

    return (
        <div data-testid="referral-leaderboard" className={`glass mt-4 border border-white/10 p-4 sm:p-5 ${shape}`}>
            <div className="flex items-center justify-between gap-3">
                <p className="flex items-center gap-2 font-display text-sm font-extrabold uppercase tracking-tight">
                    <Trophy className="h-4 w-4 text-amber-400" /> Referral race
                </p>
                <span className="text-[10px] text-zinc-500">Season ends {ends}</span>
            </div>
            <p className="mt-1 text-[11px] text-zinc-400">
                {data.prize}. <span className="text-amber-300/90">Every 5 paid sign-ups = a free month along the way.</span>
            </p>
            {data.leaders.length === 0 ? (
                <p data-testid="leaderboard-empty" className="mt-3 rounded-xl border border-dashed border-white/10 py-4 text-center text-xs text-zinc-500">
                    No scores yet this season — your name could be first. Share your link from Settings → Referrals.
                </p>
            ) : (
                <div className="mt-3 space-y-1.5" data-testid="leaderboard-list">
                    {data.leaders.map((l, i) => (
                        <div key={i} data-testid="leaderboard-row" className={`flex items-center gap-3 rounded-lg border px-3 py-2 text-xs ${i === 0 ? "border-amber-500/40 bg-amber-500/10" : "border-white/10 bg-white/[0.03]"}`}>
                            <span className={`w-5 text-center font-display text-sm font-black ${i === 0 ? "text-amber-300" : "text-zinc-500"}`}>{i + 1}</span>
                            {i === 0 && <Crown className="h-3.5 w-3.5 text-amber-400" />}
                            <span className="min-w-0 flex-1 truncate font-semibold text-zinc-200">{l.name}</span>
                            <span className="font-bold text-orange-300">{l.qualified} paid</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
